'use strict';
import React from 'react';

/**
 * Drop downs can be used to allow the user to select a single item, or multiple items.
 * They can also be used in connection with the Selected Items component (see below).
 * The drop down styles can be used independently of an input element, but may require width adjustment.
 * Because clarity component styles are largely independent, an .is-active state class
 * should be applied to InputField-input, InputField-iconButton, and DropDown-menu
 * in order to display the full active state of all elements.
 *
 * @extends {React.Component}
 */
class Dropdown extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render() {
    return (
      <div className="DropDown">
          {this.props.children}
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/dropdown/dropdown.jsx